// Angular
import { Component, OnInit, OnDestroy, ChangeDetectorRef, ElementRef, ViewChild, Input, Output, EventEmitter, TemplateRef, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
// Material
import { MatDialog } from '@angular/material/dialog';
// RxJS
import { Observable, BehaviorSubject, Subscription, of, Subject } from 'rxjs';
import { delay, take } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// import { AppState } from '../../../../../core/reducers';
// Layout
import { SubheaderService, LayoutConfigService } from '../../../../../core/_base/layout';
// CRUD
import { LayoutUtilsService, TypesUtilsService, MessageType } from '../../../../../core/_base/crud';
// import { Item } from '../../../../../../../core/plant-configuration';
import { User } from '../../../../../core/auth';
import { selectAuthState } from '../../../../../core/auth/_selectors/auth.selectors';
import { AppState } from '../../../../../core/reducers';
import { CompanyService } from '../../../../../core/auth/_services/company.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'kt-simple-edit',
  templateUrl: './simple-edit.component.html',
  styleUrls: ['./simple-edit.component.scss']
})
export class SimpleEditComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
	@ViewChild('wizard', {static: true}) el: ElementRef;
	@Input() summaryTemplate: TemplateRef<any>;

    @Input() name: string;
    @Input() pluralName: string;
    @Input() route: string;
    @Input() itemObs: Subject<any>;
    @Input() addObs: Subject<any>;
    @Input() editObs: Subject<any>;
    @Input() itemForm: FormGroup;
	@Input() stepList: any[];
	@Input() data: any = {};
	@Input() unique: boolean = false;
	@Input() startStep: number = 1;
    @Output() editEvent = new EventEmitter<any>();
    @Output() addEvent = new EventEmitter<any>();
    @Output() getEvent = new EventEmitter<any>();
    @Output() goBackEvent = new EventEmitter<any>();
	@Output() resetEvent = new EventEmitter<any>();
	@Output() onChangeTableInputForm = new EventEmitter<any>();

	// Public properties
	item: any;
	itemId$: Observable<number>;
	oldItem: any;
	selectedTab = 0;
	loadingSubject = new BehaviorSubject<boolean>(true);
	loading$: Observable<boolean>;
	// itemForm: FormGroup;
	hasFormErrors = false;
	// itemsDataSource: ItemsDataSource;
	itemsResult: any[] = [];
	attrItemList: any = {};
	attrItemListLoaded : boolean = false
    
	private subscriptions: Subscription[] = [];
    private user:User = new User();

	// Private password
	private componentSubscriptions: Subscription;
	// sticky portlet header margin
	private headerMargin: number;
	attrItemListFull: any = {};

	editorConfig: AngularEditorConfig = {
		editable: true,
		  spellcheck: true,
		  height: 'auto',
		  minHeight: '0',
		  maxHeight: 'auto',
		  width: 'auto',
		  minWidth: '0',
		  translate: 'yes',
		  enableToolbar: true,
		  showToolbar: true,
		  placeholder: 'Ingrese el texto aquí...',
		  defaultParagraphSeparator: '',
		  defaultFontName: '',
		  defaultFontSize: '',
		  fonts: [
			{class: 'arial', name: 'Arial'},
			{class: 'times-new-roman', name: 'Times New Roman'},
			{class: 'calibri', name: 'Calibri'},
			{class: 'comic-sans-ms', name: 'Comic Sans MS'}
		  ],
		  customClasses: [
		  {
			name: 'quote',
			class: 'quote',
		  },
		  {
			name: 'redText',
			class: 'redText'
		  },
		  {
			name: 'titleText',
			class: 'titleText',
			tag: 'h1',
		  },
		],
		// uploadUrl: 'v1/image',
		// upload: (file: File) => { ... }
		uploadWithCredentials: false,
		sanitize: true,
		toolbarPosition: 'top',
		toolbarHiddenButtons: [
		  ['bold', 'italic'],
		  ['fontSize']
		]
	};
	active: any;
	filename: any;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 * @param activatedRoute: ActivatedRoute
	 * @param router: Router
	 * @param typesUtilsService: TypesUtilsService
	 * @param formBuilder: FormBuilder
	 * @param dialog: MatDialog
	 * @param subheaderService: SubheaderService
	 * @param layoutUtilsService: SubheaderService
	 * @param layoutConfigService: LayoutConfigService
	 * @param cdr: ChangeDetectorRef
	 */
	constructor(
		private store: Store<AppState>,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private typesUtilsService: TypesUtilsService,
		private formBuilder: FormBuilder,
		public dialog: MatDialog,
		private subheaderService: SubheaderService,
		private layoutUtilsService: LayoutUtilsService,
		private layoutConfigService: LayoutConfigService,
		private cdr: ChangeDetectorRef,
		private companyService:CompanyService
	) { }
	ngOnChanges(changes: SimpleChanges): void {
		console.log('simple edit - ng on changes')
		// const wizard = new KTWizard(this.el.nativeElement, {
		// 	startStep: 1
		// });

		// // Validation before going to next page
		// wizard.on('beforeNext', (wizardObj) => {
		// 	// https://angular.io/guide/forms
		// 	// https://angular.io/guide/form-validation

		// 	// validate the form and use below function to stop the wizard's step
		// 	// wizardObj.stop();
		// });

		// // Change event
		// wizard.on('change', () => {
		// 	setTimeout(() => {
		// 		KTUtil.scrollTop();
		// 	}, 500);
		// });
	}

	getCurrentCompany(){
		const currentCompany = this.companyService.getCurrentCompany();
    if(currentCompany == null){
      return "Compañia sin definir"
    }
    return currentCompany.name;
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		this.subscriptions.forEach(sub=>sub.unsubscribe());
		console.log("simple edit - ng on init")
		this.user.clear();

		const authSubscription = this.store.pipe(
			select(selectAuthState),
		).subscribe((auth) => {
			// console.log("auth state: "+JSON.stringify(auth));
			if(auth.isUserLoaded)
				this.user = auth.user;
			else
				console.log("item edit component: usuario no logueado");
		});

		this.loading$ = this.loadingSubject.asObservable();
		this.loadingSubject.next(true);

		this.activatedRoute.params.subscribe(params => {
			console.log("simple edit - route params: ");console.dir(params);
			const id = params.id;
			if (id && id > 0) {
				console.log("simple edit - emit get event with ", id);
				this.getEvent.emit(id);
				const sub = this.itemObs.subscribe((item)=>{
					console.log(`simple edit - item obs: `);console.dir(item);
					if(item){
                        this.item = item;
                        this.loadItem(item);
                    }
				});
				this.subscriptions.push(sub);
			} else {
                var item:any = {};
                this.loadItem(item);
			}
		});
        // this.loadItems();
        
		
		this.subscriptions.push(authSubscription);
	}

	ngAfterViewInit(){
		// sticky portlet header
		window.onload = () => {
			const style = getComputedStyle(document.getElementById('kt_header'));
			this.headerMargin = parseInt(style.height, 0);
		};
		const wizard = new KTWizard(this.el.nativeElement, {
			startStep: this.startStep
		});

		// Validation before going to next page
		wizard.on('beforeNext', (wizardObj) => {
			// https://angular.io/guide/forms
			// https://angular.io/guide/form-validation

			// validate the form and use below function to stop the wizard's step
			// wizardObj.stop();
		});

		// Change event
		wizard.on('change', () => {
			setTimeout(() => {
				KTUtil.scrollTop();
			}, 500);
		});
	}

	assignToAttrList(inputName){
		console.log(`input name: ${inputName}`);
		const inputConfig = this.getInputConfig(inputName);
		console.log("input config: "); console.dir(inputConfig);
		if(inputConfig == null) return;

		if(inputConfig.type=='multiple' || inputConfig.type=='multiple-string'){
			const attr = this.itemForm.controls[inputName].value;	
			console.log("attr");console.dir(attr);
			console.log("attr item by input name");console.dir(this.attrItemList[inputName]);
			if(attr==-1) return;
			
				if(this.attrItemList[inputName] && (this.unique == false || this.attrItemList[inputName].indexOf(attr)==-1)){
					this.attrItemList[inputName].push(attr);
				}else{
					this.attrItemList[inputName] = [attr];
				}
				inputConfig.selected = this.attrItemList[inputName];
			console.log("attr item by input name AFTER");console.dir(this.attrItemList[inputName]);
		}else if(inputConfig.type=='multiple-list'){
			const attr = inputConfig.listList.map(list=>this.itemForm.controls[list.name].value)
			
			// console.log("attr new");
			// console.dir(attr);
			if(this.attrItemList[inputName]){
				this.attrItemList[inputName].push(attr);
			}else{
				this.attrItemList[inputName] = [attr];
			}

			this.attrItemListFull[inputName] = this.getAttrList(inputName);
			inputConfig['selected'] = this.attrItemListFull[inputName];
			console.dir(inputConfig);
		}
		
		this.cdr.detectChanges();
	}

	unassignToAttrList(inputName, attrItem){
		console.log("asfasdfasdf")
		const attr = attrItem.value;
		const inputConfig = this.getInputConfig(inputName);		
		console.log(`trying to delete from ${inputName}`);console.dir(attrItem);
		console.dir(this.attrItemList[inputName]);

		// console.log(this.attrItemListFull[inputName].indexOf(attrItem));
		if(this.attrItemList[inputName]){
			if(inputConfig.type=='multiple-list'){
				// this.attrItemList[inputName] = this.attrItemList[inputName].filter(attrEl=>attrEl!=attr);
				const idx = this.attrItemListFull[inputName].indexOf(attrItem);
				console.dir(this.attrItemList[inputName]);
				// console.log(`index: ${idx}`);
				if(idx<0) return;
				this.attrItemList[inputName].splice(idx, 1);
				this.attrItemListFull[inputName] = this.getAttrList(inputName);
				inputConfig['selected'] = this.attrItemListFull[inputName];
				console.dir(this.attrItemList[inputName]);
				console.dir(this.attrItemListFull);
			}else if(inputConfig.type=='multiple-string'){
				console.log(`deleting attr item '${attr}'  from this list`);
				console.dir(this.attrItemList[inputName]);				
				this.attrItemList[inputName] = this.attrItemList[inputName].filter(attrEl=>attrEl!=attr);
				this.attrItemListFull[inputName] = this.getAttrList(inputName);
				console.dir(this.attrItemList[inputName]);
				console.dir(this.attrItemListFull);
				inputConfig.selected = this.attrItemList[inputName];
			}else{
				// console.log("unassign attr list")
				console.dir(this.attrItemList[inputName]);
				this.attrItemList[inputName] = this.attrItemList[inputName].filter(attrEl=>attrEl!=attr);
				this.attrItemListFull[inputName] = this.getAttrList(inputName);
				console.dir(this.attrItemList[inputName]);
				console.dir(this.attrItemListFull);
				inputConfig.selected = this.attrItemList[inputName];
			}
		}
		this.cdr.detectChanges();
	}

	getAttrList(inputName){
		// console.log("GET ATTR LIST")
		const inputConfig = this.getInputConfig(inputName);
		// console.dir(inputConfig);
		if(inputConfig == null) return [];
		let attrList = [];
		if(this.attrItemList[inputName]!=undefined){
			if(inputConfig.type=='multiple'){
				attrList = this.attrItemList[inputName].map(
					value => inputConfig.optionList.find(el=>el.value == value)
				);
				
				// console.dir(this.attrItemList[inputName])
				// console.dir(attrList);
			}else if(inputConfig.type=='multiple-string'){
				attrList = this.attrItemList[inputName].map(el=>{return {text: el, value:el}});
				// console.dir(attrList);
			}else if(inputConfig.type=='multiple-list'){
				attrList = this.attrItemList[inputName].map(
					(valueList) => valueList.map(
						(value, idx)=>inputConfig.listList[idx].optionList.find(el=>el.value == value)
					)
				);
			}
		}
		// console.dir(attrList);
		// console.log("END GET ATTR LIST")
		return attrList;
	}

	getInputConfig(inputName){
		try{
			for(let step of this.stepList){
				for(let row of step.form){
					for(let input of row){
						if(input.name == inputName){
							return input;
						}
					}
				}
			}
		}catch(err){
			console.log(err);
		}
		
		return null;
	}
	
	onItemLoaded(){
		for(let step of this.stepList){
			for(let row of step.form){
				for(let input of row){
					// console.dir(input);
					if(input.type == 'multiple' || input.type == 'multiple-string'){
						this.attrItemList[input.name] = input.selected;
						
						if(this.attrItemList[input.name].length==0){
							this.itemForm.controls[input.name].patchValue(-1);
						}
					}else if(input.type == 'multiple-list'){
						this.attrItemList[input.name] = input.selected.map(selList=>selList.map(selItem=>selItem.value));
						this.attrItemListFull[input.name] = input.selected;
						console.dir(this.attrItemList[input.name])
						console.dir(this.attrItemListFull[input.name])
					}
				}
			}
		}
		
		this.attrItemListLoaded = true;
		this.cdr.detectChanges();
	}

	loadItem(item: any, fromService: boolean = false) {
		if (!item) {
			this.goBack('');
		}
		// console.log("loading item: "+JSON.stringify(item));
		this.item = Object.assign({}, item);
		// console.log("item loaded: "+JSON.stringify(this.item));
		this.itemId$ = of(item.id);
		this.oldItem = Object.assign({}, item);

		this.initItem();
		
		if (fromService) {
			this.cdr.detectChanges();
		}

		this.onItemLoaded();
  	}

	/**
	 * On destroy
	 */
	ngOnDestroy() {
		this.loadingSubject.next(false);
		if (this.componentSubscriptions) {
			this.componentSubscriptions.unsubscribe();			
		}
		this.subscriptions.forEach((sub)=>sub.unsubscribe());
	}

	/**
	 * Init item
	 */
	initItem() {
		// console.log("create form");
		this.createForm();
		this.loadingSubject.next(false);
		// if (!this.item.id) {
		// 	this.subheaderService.setBreadcrumbs([
		// 		{ title: `Listado de ${this.pluralName}`, page: `${this.route}` },
		// 		{ title: `Crear ${this.name}`, page: `${this.route}/add` }
		// 	]);
		// 	return;
		// }
		// this.subheaderService.setTitle(`Crear ${this.name}`);
		// this.subheaderService.setBreadcrumbs([
		// 	{ title: `Listado de ${this.name}`, page: `${this.route}` },
		// 	{ title: `Editar ${this.name}`, page: `${this.route}/edit`, queryParams: { id: this.item.id } }
		// ]);
	}

	/**
	 * Create form
	 */
	createForm() {
		// console.log("creating item form");
		// console.log(JSON.stringify(this.item));
		// this.itemForm = this.formBuilder.group(this.itemFormOptions);
		// console.log(`itemFormOptions: ${JSON.stringify(this.itemFormOptions)}`);
		// const controls = this.itemForm.controls;
		// const nameSub = controls.name.valueChanges.subscribe(x=>{
		// 	this.item.name = x;
        // });
        // const iiotSub = controls.iiot_code.valueChanges.subscribe(x=>{
		// 	this.item.iiot_code = x;
		// });
		// const velSub = controls.velMax.valueChanges.subscribe(x=>{
		// 	this.item.vel_max = x;
		// });
		// const dataSub = controls.dataConversion.valueChanges.subscribe(x=>{
		// 	this.item.data_conversion = x;
		// });
		// const posSub = controls.pos.valueChanges.subscribe(x=>{
		// 	this.item.vel_max = x;
		// });
		// this.subscriptions.push(nameSub);
		// this.subscriptions.push(iiotSub);
		// this.subscriptions.push(velSub);
		// this.subscriptions.push(dataSub);
		// this.subscriptions.push(posSub);
		
		Object.keys(this.item).forEach(key=>{
			if(this.itemForm.controls[key] && this.item[key]){
				try{
					console.log(`patching ${key} to ${this.item[key]}`)
					this.itemForm.controls[key].patchValue(this.item[key]);
				}catch(error){
					console.log(error);
				}
			}
		});
		Object.keys(this.itemForm.controls).forEach(key=>{
			this.subscriptions.push(
				this.itemForm.controls[key].valueChanges.subscribe(x=>{
					// console.log(`${key} changes to ${x}`);
					this.item[key] = x;
				})
			);
		})
		this.cdr.detectChanges();
	}

	onChangeStringList(stringList, input){
		this.attrItemList[input.name] = stringList;
		input.selected = stringList;
	}

	onChangeTableInputList(valueList, input){
		this.attrItemList[input.name] = valueList;
		input.selected = valueList;
	}

	/**
	 * Go back to the list
	 *
	 * @param id: any
	 */
	goBack(id) {
		// console.log(`going back to ${this.route}`);
		this.loadingSubject.next(false);
		const url = `${this.route}`;
		console.log(`going back to ${this.route}/${id}`)
		this.router.navigateByUrl(url, /* Removed unsupported properties by Angular migration: relativeTo. */ {});
	}

	goBackWithoutId() {
		this.goBackEvent.emit({});
		console.log(`going back to ${this.route}`)
		this.router.navigateByUrl(`${this.route}`, /* Removed unsupported properties by Angular migration: relativeTo. */ {});
	}

	/**
	 * Refresh item
	 *
	 * @param isNew: boolean
	 * @param id: number
	 */
	refreshItem(isNew: boolean = false, id = 0) {
		this.loadingSubject.next(false);
		let url = this.router.url;
		if (!isNew) {
			this.router.navigate([url], { relativeTo: this.activatedRoute });
			return;
		}

		url = `${this.route}/edit/${id}`;
		this.router.navigateByUrl(url, /* Removed unsupported properties by Angular migration: relativeTo. */ {});
	}

	/**
	 * Reset
	 */
	reset() {
		this.item = Object.assign({}, this.oldItem);
		Object.keys(this.itemForm.controls).forEach(key => {
			const control = this.itemForm.controls[key];
			if (control instanceof FormArray) return;
			control.reset(Object.prototype.hasOwnProperty.call(this.oldItem, key) ? this.oldItem[key] : null);
		});
		this.hasFormErrors = false;
		this.itemForm.markAsPristine();
		this.itemForm.markAsUntouched();
		this.itemForm.updateValueAndValidity();
		this.resetEvent.emit();
	}

	/**
	 * Save data
	 *
	 * @param withBack: boolean
	 */
	onSumbit(withBack: boolean = false) {
		this.hasFormErrors = false;
		const controls = this.itemForm.controls;
		/** check form */
		if (this.itemForm.invalid) {
			console.log("submit form: ", this.itemForm)
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			this.getFormValidationErrors();
			this.hasFormErrors = true;
			this.selectedTab = 0;
			return;
		}

		// tslint:disable-next-line:prefer-const
		let item = this.prepareData();

		if (item.id > 0) {
			this.updateItem(item, withBack);
			return;
		}

		this.addItem(item, true);
	}

	getFormValidationErrors() {
		Object.keys(this.itemForm.controls).forEach(key => {	  
			const controlErrors: ValidationErrors = this.itemForm.get(key).errors;
			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				});
			}
		});
	}

    //Debiese ir esto en el componente padre
	// /**
	//  * Returns object for saving
	//  */
	prepareData(): any {
		const controls 			= this.itemForm.controls;
		let item = Object.assign({}, this.item);
        for(let key of Object.keys(controls)){
            item[key] = controls[key].value;
        }
		item.attributes = this.attrItemList;
		return item;
	}

	/**
	 * Add Item
	 *
	 * @param item: Item
	 * @param withBack: boolean
	 */
	addItem(item:any, withBack:boolean = false) {
		this.loadingSubject.next(true);
		const addBreedingSub = this.addObs.pipe(
            delay(250),
            take(1),
		).subscribe(newId => {
			if (!newId || newId==-1 ) {
				this.loadingSubject.next(false);
				// addBreedingSub.unsubscribe();
				return;
			}
            
			this.loadingSubject.next(false);
			if (withBack) {
				this.goBack(newId);
			} else {
				const message = `Registro de ${this.name} ha sido creado exitosamente.`;
				this.layoutUtilsService.showActionNotification(message, MessageType.Create, 10000, true, true);
				this.refreshItem(true, newId);
			}
			// addBreedingSub.unsubscribe();
		});
		this.subscriptions.push(addBreedingSub);
		this.addEvent.emit(item);
	}

	/**
	 * Update item
	 *
	 * @param item: Item
	 * @param withBack: boolean
	 */
	updateItem(item: any, withBack: boolean = false) {
		this.loadingSubject.next(true);
		const updateBreedingSub = this.editObs.pipe(
			delay(250),
			take(1)
		).subscribe((id) => { // Remove this line
			if (!id || id!=item.id) {
				this.loadingSubject.next(false);
				// updateBreedingSub.unsubscribe();
				return;
			}
			this.loadingSubject.next(false);
			if (withBack) {
				this.goBack(item.id);
			} else {
                if(id!=item.id){
                    const message = `Registro de ${this.name} no ha podido ser modificado.`;
                    this.layoutUtilsService.showActionNotification(message, MessageType.Update, 10000, true, true);
                }else{
                    const message = `Registro de ${this.name} ha sido modificado exitosamente.`;
                    this.layoutUtilsService.showActionNotification(message, MessageType.Update, 10000, true, true);
                }
				// this.refreshItem(false);
				this.goBackWithoutId();
			}
			// updateBreedingSub.unsubscribe();
		}); // Remove this line
		this.subscriptions.push(updateBreedingSub);
		this.editEvent.emit(item);
	}

	/**
	 * Returns component title
	 */
	getComponentTitle() {
		let result = `Crear ${this.name}`;
		if (!this.item || !this.item.id) {
			return result;
		}

		result = `Editar ${this.name}`;
		return result;
	}

	/**
	 * Close alert
	 *
	 * @param $event
	 */
	onAlertClose($event) {
		this.hasFormErrors = false;
	}

	setActive(active) {
        this.active = active;
    }

	onFileChange(event, input) {
        if (input.onFileChange == undefined) return;
        this.filename = this.itemForm.controls[input.name].value.split('\\').pop();
        input.onFileChange(event);

    }
}
